
/**
 * 강사 응답
 */
export type GetReview200AllOfTwoInstructorResponse = {
  /** 응답 내용 */
  content: string;
  /** 응답일시 */
  createdAt: string;
  /** 응답 ID */
  id: string;
  /** 강사 이름 */
  instructorName: string;
  /** 수정일시 */
  updatedAt?: string;
};
